import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib/cn';

function scorePassword(password: string): 0 | 1 | 2 | 3 | 4 {
  if (!password) return 0;
  let score = 0;
  if (password.length >= 12) score++;
  if (password.length >= 16) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[a-z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;
  // Map raw score to 0-4
  if (score <= 1) return 1;
  if (score === 2) return 2;
  if (score <= 4) return 3;
  return 4;
}

const LEVEL_COLORS = ['', 'bg-destructive', 'bg-warning', 'bg-info', 'bg-success'] as const;

const LEVEL_KEYS = [
  '',
  'auth.passwordStrength.weak',
  'auth.passwordStrength.fair',
  'auth.passwordStrength.good',
  'auth.passwordStrength.strong',
] as const;

interface PasswordStrengthProps {
  password: string;
}

export function PasswordStrength({ password }: PasswordStrengthProps) {
  const { t } = useTranslation();
  const score = scorePassword(password);

  if (!password) return null;

  return (
    <div className="space-y-1.5 mt-1.5">
      <div className="flex gap-1">
        {[1, 2, 3, 4].map((level) => (
          <div
            key={level}
            className={cn(
              'h-1 flex-1 rounded-full transition-all duration-300',
              level <= score ? LEVEL_COLORS[score] : 'bg-muted',
            )}
          />
        ))}
      </div>
      <p
        className={cn(
          'text-xs',
          score >= 3 ? 'text-success' : score >= 2 ? 'text-warning' : 'text-destructive',
        )}
      >
        {t(LEVEL_KEYS[score])}
      </p>
    </div>
  );
}
